import { ITopPathAndSlice } from '../../TopPathsChart/TopPathsGroup';
import { useMemo } from 'react';
import useCacheLlmRawDataEffect from './useCacheLlmRawDataEffect';

interface IProps {
  analysisId: string;
  baseTopPathAndSlice: ITopPathAndSlice[];
  slicesTopPathAndSlice: ITopPathAndSlice[];
}

const topPathRawData = (topPathAndSlice: ITopPathAndSlice) => {
  const { topPath } = topPathAndSlice;
  if (!topPath.funnel) {
    return null;
  }
  const { data } = topPath.funnel;
  return data.columns
    .map((column) => {
      const { name, values } = column;
      return JSON.stringify({ name, values });
    })
    .join(', ');
};

const useCacheTopPathsLlmRawDataEffect = ({
  analysisId,
  baseTopPathAndSlice,
  slicesTopPathAndSlice,
}: IProps) => {
  const rawData = useMemo(() => {
    const hasDivider =
      baseTopPathAndSlice.length > 0 && slicesTopPathAndSlice.length > 0;
    const ret = [
      'This Top Paths chart consists of multiple Funnel charts produced from the following data:',
    ];
    if (hasDivider) {
      ret.push('');
      ret.push('Above the divider');
    }
    baseTopPathAndSlice.forEach((value) => {
      const toPush = topPathRawData(value);
      if (toPush) {
        ret.push(toPush);
      }
    });
    if (hasDivider) {
      ret.push('');
      ret.push('Below the divider');
    }
    slicesTopPathAndSlice.forEach((value) => {
      const toPush = topPathRawData(value);
      if (toPush) {
        ret.push(toPush);
      }
    });
    return ret.join('\n');
  }, [baseTopPathAndSlice, slicesTopPathAndSlice]);

  useCacheLlmRawDataEffect({ analysisId, rawData });
};

export default useCacheTopPathsLlmRawDataEffect;
